












import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class SearchBar extends Vue {
  @Prop() public changeSearchKeyword!: any;

  private keyword: string = '';

  private handleSearch(e: any) {
    e.preventDefault();

    this.changeSearchKeyword(this.keyword);
  }
}
